import log from 'loglevel';
import { ApiService } from './ApiService';
import { ApiEndpoints } from '@/constants/ApiEndpoints';
import { TokenRequiredStrategy } from '../strategies/TokenRequiredStrategy';
import { LeaderboardResponse } from '@/interfaces/Leaderboard/LeaderboardResponse';

class LeaderboardServiceClass extends ApiService {
    private LEADERBOARD_ENDPOINT = ApiEndpoints.LEADERBOARD;

    constructor() {
        super(TokenRequiredStrategy);
    }

    async getLeaderboard(): Promise<LeaderboardResponse> {
        try {
            const response = await this.get(this.LEADERBOARD_ENDPOINT);
            return response;
        } catch (error) {
            log.error('Failed to get leaderboard:', error);
            throw error;
        }
    }
}

export const LeaderboardService = new LeaderboardServiceClass();